import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { GetSupportTicketsResponse } from "@src/types/support";

export const getMySupportTicketsWithLanguage = async (
  namespace: string,
  language: string,
): Promise<{ data: GetSupportTicketsResponse }> => {
  const url = supportUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<GetSupportTicketsResponse>(
      `${url}/api/v1/ns/${namespace}/tickets/mine`,
      {
        headers,
        params: {
          language,
        },
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch tickets. Please try again later.",
      );
    }
    throw new Error("An unexpected error occurred while fetching tickets.");
  }
};
